const mutation = {
  setPersonalInfoChecklist(state, { data }) {
    state.personalInfoChecklist = data;
  },
}

export default mutation